var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { padding: "0 20px", background: "#fff" } },
    [
      _c(
        "a-tabs",
        {
          attrs: { activeKey: _vm.activeKey, destroyInactiveTabPane: "" },
          on: { change: _vm.changeTab },
        },
        _vm._l(_vm.tabList, function (item, index) {
          return _c(
            "a-tab-pane",
            { key: item.key, attrs: { tab: item.tab } },
            [
              _c(item.type, {
                ref: "paneRef",
                refInFor: true,
                tag: "component",
                attrs: { actionUrl: "ceremony" },
              }),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }